import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { NegativeKeywordsTable } from '../components/keywords/NegativeKeywordsTable'
import { TableStore } from '../components/table2/table_store'
import { useSavedFiltersStore } from '../hooks/useSavedFiltersStore'
import { useUser } from '../hooks/useUser'
import { useTableHooksFromStore } from '../packages/blueprint-components/src/useTableHooks'
import { userStore } from '../stores/user_store'
import { adManagerPerformanceGet } from '../util/adManagerPerformanceApi'

export const NegativeKeywords = observer(({}) => {
    const { profile } = useUser()
    const savedFiltersStore = useSavedFiltersStore()
    const [store] = useState(new TableStore<any>(userStore, 'negative keywords'))

    const load = (params: any) => {
        if (!profile) {
            return Promise.resolve()
        }

        return adManagerPerformanceGet('api/v5/negative-keywords', params, true)
    }

    const tableHooks = useTableHooksFromStore(load, {}, false, store)
    return (
        <NegativeKeywordsTable
            tableHooks={tableHooks}
            store={store}
            savedFiltersStore={savedFiltersStore}
        />
    )
})
